import { render, staticRenderFns } from "./printContent.vue?vue&type=template&id=6d8f1888&"
import script from "./printContent.vue?vue&type=script&lang=js&"
export * from "./printContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports